var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isAdmin)?_c('v-btn',{attrs:{"color":"red","icon":""},on:{"click":function($event){return _vm.$emit('click')}}},[_c('v-icon',[_vm._v("mdi-delete")])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }